import React from "react";
import {
  BrowserRouter as Router,
  Routes as RouterRoutes,
  Route,
  Navigate,
} from "react-router-dom";

import session from "./Utils/session";

import Auth from "./Screens/Auth";
import AuthCallback from "./Screens/AuthCallback";
import Main from "./Screens/Main";
import SignUp from "./Screens/SignUp";
import LandingPage from "./Screens/LandingPage";
import ForgotPassword from "./Screens/ForgotPassword";
import ResetPassword from "./Screens/ResetPassword";
import SubmitPage from "./Screens/SubmitPage";

function Routes() {
  return (
    <Router>
      <RouterRoutes>
        <Route path="/app/*" element={<PrivateRoute component={Main} />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/submit/:token" element={<SubmitPage />} />
        <Route path="/join/:code" element={<SignUp />} />
        <Route path="/join/" element={<SignUp />} />
        <Route path="/" element={<LandingPage isMobile={navigator.userAgent.includes("Mobile")} />} />
      </RouterRoutes>
    </Router>
  );
}

function PrivateRoute({ component: Component }) {
  return session.isAuthenticated() ? (
    <Component />
  ) : (
    <Navigate to="/auth" replace />
  );
}

export default Routes;
